module.exports = __webpack_public_path__ + "img/iso-text-creditu.77f48070.svg";